import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useDemoStore } from "./demoStore";
import { DEMO_CMM_IMPORT } from "./seedData";

/**
 * Demo-only behaviour for the CMM import screen: prefill the form with canned
 * data, then auto-advance into the live PA flow once an order is "imported".
 * No-op outside demo mode, so the production page stays demo-free.
 */
export function useDemoCmmImport({
  submissionKey,
  patientLastName,
  patientDobDate,
  extraContextNotes,
  supplementalDocs,
  importedOrderKey,
}) {
  const demoStore = useDemoStore();
  if (!demoStore.active) return;

  const router = useRouter();

  onMounted(() => {
    const [y, m, d] = DEMO_CMM_IMPORT.patient_dob.split("-").map(Number);
    submissionKey.value = DEMO_CMM_IMPORT.submission_key;
    patientLastName.value = DEMO_CMM_IMPORT.patient_last_name;
    patientDobDate.value = new Date(y, m - 1, d);
    extraContextNotes.value = DEMO_CMM_IMPORT.extra_context_notes;
    supplementalDocs.value = DEMO_CMM_IMPORT.supplemental_docs.map((doc) => ({ ...doc }));
  });

  watch(importedOrderKey, (key) => {
    if (!key) return;
    setTimeout(() => {
      router.push({ name: "demo-prior-auth" });
      setTimeout(() => demoStore.startFlowFromAutocomplete(key), 400);
    }, 1500);
  });
}
